import { procHistoryDesignation } from '@lib/procurement';
import type { ProcHistoryEntry } from '@type/store';

export default function ProcActivityHistorySection({ history }: { history: ProcHistoryEntry[] }) {
  const items = Array.isArray(history) ? history : [];
  if (!items.length) return null;

  return (
    <div className="proc-detail-span2 proc-activity-history">
      <div className="cm-form-sec-title">Activity History</div>
      <div className="tbl-wrap civ-scroll proc-history-table">
        <table>
          <thead>
            <tr>
              <th>When</th>
              <th>Action</th>
              <th>Designation</th>
              <th>Status Change</th>
            </tr>
          </thead>
          <tbody>
            {items.map((h, i) => (
              <tr key={`${h.at}-${i}`}>
                <td className="t-muted">{h.at || '—'}</td>
                <td className="t-wrap-sm">{h.action || '—'}</td>
                <td className="t-wrap-sm">{procHistoryDesignation(h)}</td>
                <td className="t-wrap-sm">{h.from && h.to ? `${h.from} → ${h.to}` : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
